import React from 'react';
import JumpingWoman from '../../assets/img/jumping-woman.svg';

function SharePlaceDonePage() {
  return (
    <div className="relative">
      <div className="h4 center pb2">
        Děkujeme že sdílíte své místo s kolegy,
        <br />
        určitě to Váši kolegové ocení!
      </div>
      <img className="juping-woman" src={JumpingWoman} alt="Radující se žena" />
    </div>
  );
}

export default SharePlaceDonePage;
